import { createApp } from 'vue'
import App from './App.vue'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import {createPinia, setActivePinia} from "pinia";
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'


/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faPenToSquare, faUser, faCircleMinus, faArrowsRotate, faFloppyDisk } from '@fortawesome/free-solid-svg-icons'

import router from './router'
import {setUnauthorizedHandler} from './services/grpc'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
/* add icons to the library */
library.add(faPenToSquare, faUser, faCircleMinus, faArrowsRotate, faFloppyDisk)

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)
setActivePinia(pinia)

setUnauthorizedHandler(() => {
    if (router.currentRoute.value.meta.public) {
        return;
    }
    router.push({name: 'Login', query: {redirect: router.currentRoute.value.fullPath}});
})

createApp(App)
    .use(Quasar, quasarUserOptions)
    .use(pinia)
    .use(router)
    .use(VueSidebarMenu)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
